import { IMessage } from '@weblite/ts-action/message'
import { Message } from '$common/chat-list-item-new/components/message'
import { useEventMessageText } from '$logic/message/react-hook'

export function EventTitle({ lastMessage }: { lastMessage: IMessage }) {
  const { eventText, loading } = useEventMessageText(lastMessage)

  if (loading) return null
  return <Message event={eventText} />
}
